/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (type, parent, zone)
  {
    this.type = type;
    this.parent = parent;
    this.zone = zone;
  }


  getID ()
  {
    return this.type.id;
  }


  // TODO ?
  getUser ()
  {
    return this.parent.getUser();
  }


  getPlanet ()
  {
    return this.type.planet;
  }


  getSector ()
  {
    return this.type.sector;
  }


  getCoords ()
  {
    return this.type.coords;
  }


  getLocation ()
  {
    return this.type.location;
  }


  getControl (user)
  {
    const found = this.getControlCollection().find(value => value.user === user);

    return found ? found.value : 0;
  }


  getControlCollection ()
  {
    return this.type.control;
  }


  getEnergy (user)
  {
    const found = this.getEnergyCollection().find(value => value.user === user);

    return found ? found.value : 0;
  }


  getEnergyCollection ()
  {
    return this.type.energy;
  }


  getResistance (user)
  {
    const found = this.getResistanceCollection().find(value => value.user === user);

    return found ? found.value : 0;
  }


  getResistanceCollection ()
  {
    return this.type.resistance;
  }


  getDirections ()
  {
    return this.type.directions;
  }


  getResource ()
  {
    return this.type.resource;
  }


  isOverheat ()
  {
    return this.type.overheat;
  }


  isCritical ()
  {
    return this.type.critical;
  }


  getUpdateDate ()
  {
    return this.zone.planet.getCass().update_date;
    return this.type.update_date;
  }


  isCenter ()
  {
    return this.getCoords().equals(this.parent.getCenter());
  }


}
